export const businessInfo = {
  name: "Vape Shop #Zielarz",
  phone: {
    display: "+48 534 113 183",
    href: "tel:+48534113183",
  },
  address: {
    streetAddress: "aleja Wolności 17",
    postalCode: "42-202",
    addressLocality: "Częstochowa",
    countryCode: "PL",
  },
  plusCode: "R459+QP Częstochowa",
  geo: {
    latitude: 50.8094582,
    longitude: 19.1193402,
  },
  googleMapsPlaceUrl:
    "https://www.google.com/maps/place/Vape+Shop+%23Zielarz/@50.8094582,19.1193402,17z",
  facebookUrl: "https://www.facebook.com/p/Vape-Shop-Zielarz-100076007320738/",
}

export const businessLocationLabel = `${businessInfo.address.addressLocality}, ${businessInfo.address.streetAddress}`

const googleMapsQuery = `${businessInfo.name}, ${businessInfo.address.streetAddress}, ${businessInfo.address.postalCode} ${businessInfo.address.addressLocality}, ${businessInfo.plusCode}`

export const googleMapsEmbedUrl = `https://maps.google.com/maps?hl=pl&q=${encodeURIComponent(
  googleMapsQuery
)}&t=&z=17&ie=UTF8&iwloc=B&output=embed`

export const openingHours = [
  { dayLabelPl: "Poniedziałek", opens: "8:00", closes: "20:00" },
  { dayLabelPl: "Wtorek", opens: "8:00", closes: "20:00" },
  { dayLabelPl: "Środa", opens: "8:00", closes: "20:00" },
  { dayLabelPl: "Czwartek", opens: "8:00", closes: "20:00" },
  { dayLabelPl: "Piątek", opens: "8:00", closes: "20:00" },
  { dayLabelPl: "Sobota", opens: "12:00", closes: "20:00" },
  { dayLabelPl: "Niedziela", opens: null, closes: null },
] as const
